import { render, staticRenderFns } from "./allAnchor.vue?vue&type=template&id=c6f685b8"
import script from "./allAnchor.vue?vue&type=script&lang=js"
export * from "./allAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6f685b8')) {
      api.createRecord('c6f685b8', component.options)
    } else {
      api.reload('c6f685b8', component.options)
    }
    module.hot.accept("./allAnchor.vue?vue&type=template&id=c6f685b8", function () {
      api.rerender('c6f685b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/components/allAnchor.vue"
export default component.exports